export const PAYMENT_ICONS = [
  { file: "visa", label: "Visa" },
  { file: "elo", label: "Elo" },
  { file: "amex", label: "American Express" },
  { file: "mastercard", label: "Mastercard" },
  { file: "pix", label: "Pix" },
  { file: "boleto", label: "Boleto" },
] as const;
